import { render, staticRenderFns } from "./paymentsModal.vue?vue&type=template&id=497ad645&scoped=true&"
import script from "./paymentsModal.vue?vue&type=script&lang=js&"
export * from "./paymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ad645",
  null
  
)

export default component.exports